import React, { lazy } from "react";
import { Route } from "react-router-dom";
import { AddUser, ComponentsList, CreateNotification, Profile, Settings } from "../pages";

import { Marketplace, MarketplaceSetup } from "../pages";

import InnerMainLayout from "../pages/InnerPages/_layout/InnerMainLayout";
import { filterRoutes } from "../utils/moduleAccessUtils";
import { getItem } from "../utils/localStorageUtils";

/**
 * CommonRoutes - Contains routes that are shared across multiple portals
 * These routes are accessible regardless of the current portal (WF, ATS, PTL)
 */
const CommonRoutes = ({ moduleAccess = {}, user = {} }) => {
  const portal = getItem("portal");
  const loginUserData = user?.data || {};
  const role = loginUserData?.role?.type ?? null;
  const userModule = loginUserData?.role?.module ?? null;
  const commonRouteConfig = [
    {
      path: "/components-list/*",
      element: <ComponentsList />,
      id: "componentslist",
    },
    { path: "/settings", element: <Settings />, id: "settings" },
    { path: "/profile", element: <Profile />, id: "profile" },
    { path: "/settings/add-user", element: <AddUser />, id: "adduser" },
    { path: "/marketplace", element: <Marketplace />, id: "marketplace" },
    {
      path: "/marketplace/setup",
      element: <MarketplaceSetup />,
      id: "marketplace_setup",
    },
    { path: "/settings/notification-center/create",
       element: <CreateNotification />,
        id: "create_notification",
    }
  ];
  const accessibleRoutes = filterRoutes({
    routes: commonRouteConfig,
    modules: moduleAccess,
    role,
    accessKey:
      portal === "bs" ? "benchsales" : portal === "wf" ? "workforce" : "ats",
    userModule,
    portal
  });
  return (
    <>
      <Route element={<InnerMainLayout />}>
        {/* Components List - Available across all portals */}
        {/* <Route path="/components-list/*" element={<ComponentsList />} /> */}
        {/* Settings - Available across all portals */}
        {/* <Route path="/settings" element={<Settings />} /> */}
        {/* <Route path="/profile" element={<Profile />} /> */}

        {/* <Route path="/settings/add-user" element={<AddUser />} /> */}

        {/* Add more common routes here as needed */}
        {/* Example: */}
        {/* <Route path="/profile" element={<Profile />} /> */}
        {accessibleRoutes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
      </Route>
    </>
  );
};

export default CommonRoutes;
